import PageShell from "@/components/PageShell";
import usePageMeta from "@/lib/usePageMeta";

export const Terms = () => {
  usePageMeta({
    title: "Terms of Service — Postmark & Co.",
    description:
      "Terms governing the use of Postmark & Co. (maildirect.store), including editorial content, affiliate links to Thanks.io, disclaimers, limitation of liability, and governing law.",
    canonical: "https://maildirect.store/terms",
  });

  return (
    <PageShell testid="terms-page">
      <article className="max-w-3xl mx-auto px-6 md:px-12 prose-editorial">
        <div className="postmark text-[#D93829] mb-6">
          <span className="w-1 h-1 rounded-full bg-[#D93829]" />
          Legal
        </div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] tracking-tight text-[#1C1C1A]">
          Terms of Service
        </h1>
        <p className="text-[11px] uppercase tracking-[0.24em] text-[#68655E] mt-4">
          Last updated: December 2025
        </p>

        <div className="mt-12 space-y-6 text-[#3B3A36] text-base md:text-lg leading-relaxed font-sans-body">
          <p>
            These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the
            Postmark &amp; Co. website (maildirect.store). By accessing or
            using the site you agree to be bound by these Terms.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            1. Editorial content
          </h2>
          <p>
            Postmark &amp; Co. publishes educational content about postcard
            marketing, direct mail, and related growth strategies for U.S.
            small businesses. All content is provided for informational
            purposes only and does not constitute legal, financial, or
            marketing advice specific to your situation.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            2. Affiliate relationships
          </h2>
          <p>
            Postmark &amp; Co. is an affiliate partner of Thanks.io (partner
            code <em>ahx</em>). Certain outbound links on this site route
            through this affiliate code, and we may earn a commission when a
            reader signs up or purchases from Thanks.io through these links.
            Affiliate relationships never influence our editorial judgment.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            3. Advertising
          </h2>
          <p>
            This site displays advertisements through Google AdSense. Ads are
            served by third parties and their content is not endorsed by
            Postmark &amp; Co. See our{" "}
            <a
              href="/privacy"
              className="text-[#D93829] link-underline"
              data-testid="terms-privacy-link"
            >
              Privacy Policy
            </a>{" "}
            for details on ad cookies and your controls.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            4. No guarantee of results
          </h2>
          <p>
            While we cite third-party statistics on direct mail effectiveness,
            individual campaign results depend on many factors outside our
            control — including offer, list quality, creative, and timing.
            Postmark &amp; Co. makes no guarantee of specific response rates,
            revenue, or return on investment.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            5. Third-party services
          </h2>
          <p>
            Products, services, and websites mentioned on this site
            (including Thanks.io) are operated by independent third parties
            under their own terms and policies. Postmark &amp; Co. is not
            responsible for any transaction, product, service, or
            communication between you and a third party.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            6. Intellectual property
          </h2>
          <p>
            All original text, layout, imagery treatments, and design elements
            on this site are the intellectual property of Postmark &amp; Co.
            You may quote short excerpts with attribution and a link back;
            full reproduction requires prior written permission.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            7. Limitation of liability
          </h2>
          <p>
            To the maximum extent permitted by law, Postmark &amp; Co. shall
            not be liable for any indirect, incidental, special, consequential,
            or punitive damages arising from your use of this site or reliance
            on its content.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            8. Governing law
          </h2>
          <p>
            These Terms are governed by the laws of the United States and the
            State of Delaware, without regard to conflict of law principles.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            9. Changes
          </h2>
          <p>
            We may revise these Terms at any time. Continued use of the site
            after changes are posted constitutes acceptance of the revised
            Terms.
          </p>

          <h2 className="font-serif-display text-2xl text-[#1C1C1A] pt-4">
            10. Contact
          </h2>
          <p>
            Questions about these Terms?{" "}
            <a
              href="/contact"
              className="text-[#D93829] link-underline"
              data-testid="terms-contact-link"
            >
              Reach us here
            </a>
            .
          </p>
        </div>
      </article>
    </PageShell>
  );
};

export default Terms;
